export const blurredActionSx = {
  filter: 'blur(0.6px)',
  opacity: 0.7,
  pointerEvents: 'none',
  userSelect: 'none',
  '&.Mui-disabled': {
    filter: 'blur(0.6px)',
    opacity: 0.7,
  },
};

export const blurredPreviewSx = {
  filter: 'blur(0.5px)',
  opacity: 0.85,
  pointerEvents: 'none',
  userSelect: 'none',
};
